import React, { useState } from 'react';
import classNames from "classnames";

import inputs from "./input.module.scss";

export default (props) => {
    const { containerStyle, inputChildren, onChange, isTextArea, label, value, errorMessage, reference, pending, InlineLoaderIcon, className, maxChars, charCount, inputStyle, disabled, labelChildren, ...attributes } = props;
    const [counter, setCounter] = useState((value && value.length) || 0);

    const handleInput = (e) => {
        if (maxChars && (e.target.value.length > maxChars)) {
            return;
        }
        setCounter(e.target.value.length);
        onChange(e);
    };

    return (
        <div className={classNames(inputs["input-container"], className, {[inputs["no-label"]]: !label})} style={containerStyle}>
            {inputChildren && <div className={inputs["input-children"]}>{inputChildren}</div>}
            <label className={errorMessage ? inputs["invalid"] : ''}>
                <div className={inputs["title-and-word-counter-container"]}>
                    <span>{label}</span>{charCount && <span>{counter}/{maxChars}</span>}
                    {labelChildren}
                </div>
                {pending && InlineLoaderIcon && <InlineLoaderIcon className={inputs["inline-loader"]}/>}
                {isTextArea
                    ? <textarea {...attributes} value={value} ref={reference} onChange={handleInput} style={inputStyle} disabled={disabled}/>
                    : <input {...attributes} value={value} ref={reference} onChange={handleInput} style={inputStyle} disabled={disabled}/>}
                <div className={inputs.error}>{errorMessage}</div>
            </label>
        </div>
    );
}
